<p>contrat-item works!</p>
